"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.timezonesMocks = void 0;

var _msw = require("msw");

var getTimezonesMock = _msw.rest.get('/api/v1/timezones', function (req, res, ctx) {
  return res(ctx.json({
    data: [{
      title: 'US/Samoa',
      abbr: 'SST',
      name: 'Pacific/Pago_Pago'
    }, {
      title: 'US/Hawaii',
      abbr: 'HT',
      name: 'Pacific/Honolulu'
    }, {
      title: 'US/Aleutian',
      abbr: 'HADT',
      name: 'America/Adak'
    }, {
      title: 'US/Alaska',
      abbr: 'AT',
      name: 'America/Anchorage'
    }, {
      title: 'Canada/Pacific',
      abbr: 'PT',
      name: 'America/Vancouver'
    }, {
      title: 'Canada/Yukon',
      abbr: 'YST',
      name: 'America/Whitehorse'
    }, {
      title: 'US/Arizona',
      abbr: 'MST',
      name: 'America/Phoenix'
    }, {
      title: 'US/Pacific',
      abbr: 'PT',
      name: 'America/Los_Angeles'
    }, {
      title: 'Canada/Mountain',
      abbr: 'MT',
      name: 'America/Edmonton'
    }, {
      title: 'Canada/Saskatchewan',
      abbr: 'CST',
      name: 'America/Regina'
    }, {
      title: 'US/Mountain',
      abbr: 'MT',
      name: 'America/Denver'
    }, {
      title: 'Canada/Central',
      abbr: 'DST',
      name: 'America/Winnipeg'
    }, {
      title: 'Mexico/General',
      abbr: 'MX',
      name: 'Mexico/General'
    }, {
      title: 'US/Central',
      abbr: 'CT',
      name: 'America/Chicago'
    }, {
      title: 'US/Indiana-Starke ',
      abbr: 'EDT',
      name: 'America/Indiana/Knox'
    }, {
      title: 'Canada/Eastern',
      abbr: 'EST',
      name: 'America/Toronto'
    }, {
      title: 'US/Eastern',
      abbr: 'ET',
      name: 'America/New_York'
    }, {
      title: 'US/East-Indiana',
      abbr: 'EDT',
      name: 'America/Indiana/Indianapolis'
    }, {
      title: 'US/Michigan',
      abbr: 'EDT',
      name: 'America/Detroit'
    }, {
      title: 'Canada/Atlantic',
      abbr: 'AT',
      name: 'America/Halifax'
    }, {
      title: 'Canada/Newfoundland',
      abbr: 'NST',
      name: 'America/St_Johns'
    }, {
      title: 'America/Araguaina',
      abbr: 'BR',
      name: 'America/Araguaina'
    }, {
      title: 'America/Noronha',
      abbr: 'BR',
      name: 'America/Noronha'
    }, {
      title: 'UTC',
      abbr: 'UTC',
      name: 'UTC'
    }, {
      title: 'Europe/Central',
      abbr: 'CET',
      name: 'Europe/Lisbon'
    }, {
      title: 'Europe/London',
      abbr: 'BST',
      name: 'Europe/London'
    }, {
      title: 'Europe/Western',
      abbr: 'WET',
      name: 'Europe/Paris'
    }, {
      title: 'Europe/Eastern',
      abbr: 'EET',
      name: 'Europe/Sofia'
    }, {
      title: 'Asia/Jerusalem',
      abbr: 'IL',
      name: 'Asia/Jerusalem'
    }, {
      title: 'Asia/Hong Kong',
      abbr: 'HK',
      name: 'Asia/Hong Kong'
    }, {
      title: 'India/Kerguelen',
      abbr: 'TF',
      name: 'India/Kerguelen'
    }, {
      title: 'Asia/Baku',
      abbr: 'AZ',
      name: 'Asia/Baku'
    }, {
      title: 'Asia/Tashkent',
      abbr: 'UZ',
      name: 'Asia/Tashkent'
    }, {
      title: 'Asia/Almaty',
      abbr: 'KZ',
      name: 'Asia/Almaty'
    }, {
      title: 'Asia/Barnaul',
      abbr: 'RU',
      name: 'Asia/Barnaul'
    }, {
      title: 'Asia/Singapore',
      abbr: 'SG',
      name: 'Asia/Singapore'
    }, {
      title: 'Asia/Tokyo',
      abbr: 'JP',
      name: 'Asia/Tokyo'
    }, {
      title: 'Asia/Seoul',
      abbr: 'KR',
      name: 'Asia/Seoul'
    }, {
      title: 'Australia/Sydney',
      abbr: 'AU',
      name: 'Australia/Sydney'
    }, {
      title: 'Pacific/Auckland',
      abbr: 'NZ',
      name: 'Pacific/Auckland'
    }]
  }));
});

var timezonesMocks = [getTimezonesMock];
exports.timezonesMocks = timezonesMocks;